


























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { tagWebservice } from '@/webservices/tag';
import type { GlobalPMPhase, PMPhase } from '@/models/pmphase';
import type { PMSubPhase } from '@/models/pmsubphase';
import type { PMLesson } from '@/models/pmlesson';
import type { User } from '@/models/user';
import type { CompanySetting } from '@/models/companySetting';
import type { Tag } from '@/models/tag';
import SearchField from '@/components/prine/SearchField.vue';
import FilteringSetting from '@/components/knowledge/pm/lessons/FilteringSetting.vue';
import { FilterManager } from '@/helpers/filter/FilterManager';
import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';
import MoreInfoModal from '@/components/MoreInfoModal.vue';
import LessonsList from '@/components/knowledge/lessons/LessonsList.vue';
import { conceptWebservice } from '@/webservices/concept';

@Component({
    name: 'GlobalSubPhaseLessonsGroupedByPhase',
    components: {
        SearchField,
        FilteringSetting,
        MoreInfoModal,
        LessonsList,
    },
})
export default class GlobalSubPhaseLessonsGroupedByPhase extends Vue {
    private moreInfoShowModalActive: boolean = false;
    private moreInfoModalInsight: string;
    private moreInfoModalContent: string;
    private moreInfoModalId: number;

    private option: {
        filterByColumn: boolean;
        filterable: boolean;
    };
    private showOnlyMyLessons = false;

    private filteredElements = new Array<GlobalPMPhase>();
    private originalSubPhases = new Array<GlobalPMPhase>();

    private phases = new Array<PMPhase>();

    private selectedPhase: GlobalPMPhase = {} as GlobalPMPhase;
    private searchGlobalSubPhaseTitle: string = '';

    private allSubPhases: GlobalPMPhase = {} as GlobalPMPhase;

    private tags = new Array<Tag>();
    private selectedTag = {} as Tag;
    private allTags: Tag = {} as Tag;

    private isSearching: boolean = false;
    private searchQuery: string = '';

    private isFilteringSettingActive = false;

    private filterManager: FilterManager = new FilterManager();
    private filterOptions: FilterOptions = {} as FilterOptions;
    private tableCollapsed: boolean = false;
    private openedDetailRows: number[] = [];

    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('utils/currentLocale') private currentLocale: string;

    @Watch('searchQuery')
    private onSearchQueryValueChange() {
        this.search();
    }

    @Watch('showEmptySubphases')
    private onFiltersChanged() {
        this.filter();
    }

    get showEmptySubphases() {
        return this.$store.getters['knowledge/showEmptySubphases'];
    }

    set showEmptySubphases(value: boolean) {
        this.$store.commit('knowledge/setShowEmptySubphases', value);
    }

    private mounted() {
        this.loadTags();
        // The id is passed as string, parse it
        this.loadSelectedGlobal();
    }

    private initializeMoreInfoModal(lesson: PMLesson) {
        this.moreInfoModalContent = lesson.more_info;
        this.moreInfoModalInsight = lesson.insight;
        this.moreInfoModalId = lesson.id;
        this.moreInfoShowModalActive = true;
    }

    private loadTags() {
        tagWebservice
            .load()
            .then((response) => {
                this.tags = response.data;

                this.allTags.id = 0;
                this.allTags.title = this.$t('keywords.allTags').toString();

                this.selectedTag = this.allTags;

                // Add it in the front of the array
                this.tags.unshift(this.allTags);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private updateSearchQuery(value: string) {
        this.searchQuery = value;
    }

    private search() {
        this.isSearching = true;
        this.filter();
        this.isSearching = false;
    }

    private goBack() {
        let filterByLessons = '';
        if (this.$route.query.filterByLessons) {
            filterByLessons = this.$route.query.filterByLessons as any;
        }
        this.$router.push({
            name: 'GlobalSubPhasesContainer',
            query: {
                sq: encodeURIComponent(this.searchQuery),
                fbl: filterByLessons,
            },
        });
    }

    private loadSelectedGlobal() {
        if (this.$route.query.title) {
            this.searchGlobalSubPhaseTitle = decodeURIComponent(this.$route.query.title.toString());
        }

        this.loadPhasesWithLessons();
    }

    private async loadPhasesWithLessons() {
        this.filteredElements = await conceptWebservice.loadPmPhasesWithLessons(this.searchGlobalSubPhaseTitle);
        this.originalSubPhases = JSON.parse(JSON.stringify(this.filteredElements));

        this.phases = this.filteredElements.map((phase) => {
            return {
                id: phase.id,
                title: phase.title,
            } as PMPhase;
        });

        if (this.$route.query.sq && this.$route.query.sq !== '') {
            this.searchQuery = decodeURIComponent(this.$route.query.sq.toString());
            this.search();
        }

        this.allSubPhases.id = 0;
        this.allSubPhases.title =
            this.$t('keywords.all').toString() + this.currentLocale === 'en'
                ? this.companySetting.pm_en_process_title
                : this.companySetting.pm_de_process_title;

        this.selectedPhase = this.allSubPhases;

        // Add it in the front of the array
        this.phases.unshift(this.allSubPhases);

        this.init();
    }

    private hr(index) {
        return index > 1;
    }

    private init() {
        this.openedDetailRows = this.filteredElements.map((el) => el.id);
    }

    private clearSearch() {
        // Reset the search query
        this.searchQuery = '';
    }

    private getPhaseTitle(subPhase: PMSubPhase) {
        return subPhase.title;
    }

    private phaseChanged(value: PMSubPhase) {
        this.filter();
    }

    private tagChanged(value: Tag) {
        this.selectedTag = value;
        this.filter();
    }

    private showOnlyMyLessonsChanged(value: boolean) {
        this.showOnlyMyLessons = value;
        this.filter();
    }

    private toggleFilteringSettings() {
        this.isFilteringSettingActive = !this.isFilteringSettingActive;
    }

    private filter() {
        const data = JSON.parse(JSON.stringify(this.originalSubPhases)) as FilterData[];

        this.setFilterOptions();
        this.filteredElements = (this.filterManager.filter(data, this.filterOptions) as unknown) as GlobalPMPhase[];
    }

    get canResetFilter() {
        return (
            this.selectedTag !== this.allTags ||
            this.selectedPhase !== this.allSubPhases ||
            this.showEmptySubphases ||
            this.showOnlyMyLessons
        );
    }

    private resetFilter() {
        this.selectedTag = this.allTags;
        this.selectedPhase = this.allSubPhases;
        this.showEmptySubphases = false;
        this.showOnlyMyLessons = false;

        this.filter();
    }

    private setFilterOptions() {
        this.filterOptions.userId = this.userInfo.id;
        this.filterOptions.searchQuery = this.searchQuery;
        this.filterOptions.tag = this.selectedTag;
        // this.filterOptions.pmSubphase = this.selectedPhase;
        this.filterOptions.showEmptyElements = this.showEmptySubphases;
        this.filterOptions.onlyMyLessons = this.showOnlyMyLessons;
    }

    private toggleDetailRows() {
        if (this.tableCollapsed) {
            this.openedDetailRows = this.filteredElements.map((el) => el.id);
        } else {
            this.openedDetailRows = [];
        }
        this.tableCollapsed = !this.tableCollapsed;
    }

    private getLessonsCount(lessons: PMLesson[]) {
        const count = (cLessons: PMLesson[]): number => {
            return cLessons.reduce((base, lesson) => {
                if (lesson.sub_lessons) {
                    base += count(lesson.sub_lessons);
                }

                return base + 1;
            }, 0);
        };

        return count(lessons);
    }
}
